export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    fixed: 'left',
    field: 'sortOrder',
    align: 'left',
    width: 100,
    title: '字段顺序',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'extendFieldName',
    align: 'left',
    minWidth: 250,
    title: '扩展字段名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'controlType',
    align: 'left',
    width: 150,
    title: '界面控件类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'fieldType',
    align: 'left',
    width: 100,
    title: '字段类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'fieldLength',
    align: 'left',
    width: 135,
    title: '字段长度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'left',
    width: 100,
    title: '是否多选',
    slots: { default: 'multiple' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'left',
    width: 100,
    title: '是否必填',
    slots: { default: 'required' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'left',
    width: 100,
    title: '是否使用',
    slots: { default: 'enable' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'controlProps',
    minWidth: 300,
    align: 'left',
    title: '控件属性定义json',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
